module.exports = __webpack_public_path__ + "static/media/50.bd678c59.svg";